<mat-dialog-content>

  <div style="text-align: center;">

    <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
      <span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color7)">check_circle</span>
    </div>

    <div class="label-dialog-strong">{{title}}</div>
    <div class="label-dialog" [innerHTML]="subtitle"></div>


    <div class="row">

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" >

        <div class="btn-simpli-container">
          @if (step == 1) {
            <button class="primary-button" mat-flat-button style="width: 230px;" (click)="ver_operaciones()">
              Ver mis operaciones
            </button>
          }

          @if (step == 2) {
            <button class="primary-button" mat-flat-button style="width: 230px;" (click)="ver_estado()">
              Ver estado
            </button>
          }

        </div>

      </div>


    </div>



  </div>



</mat-dialog-content>
